import styled from 'styled-components';

interface ModalProps {
  isVisible: boolean
}

export const ModalExplanatory = styled.div<ModalProps>`
  position: absolute;
  z-index: 10;
  height: calc(100% - 57px);
  scroll-behavior: unset;
  background-color: rgba(0, 0, 0, 0.3);
  display: ${(props) => props.isVisible ? 'flex' : 'none'};
  flex-direction: column;  
  justify-content: center;
  align-items: center;
  width: calc(100% - 200px);

  @media (max-width: 900px) {
    height: calc(100vh - 114px);
    width: 100vw;
  }

  main {
    background-color: ${({ theme }) => theme.background};
    color: ${({ theme }) => theme.text};
    width: 60%;
    margin: 20px;
    padding: 30px 20px;
    border-radius: 5px;
    max-height: 90vh; 
    -ms-overflow-style: none;  
    scrollbar-width: none;
    overflow-y: scroll;
    overflow-x: hidden;
    border: 2px solid ${({ theme }) => theme.text};

    ::-webkit-scrollbar {
      display: none;
    }
    
    @media(max-width: 750px) {
      width: 70%
    }
    @media(max-width: 650px) {
      width: 80%
    }
    @media(max-width: 600px) {
      width: 85%
    }
    @media(max-width: 500px) {
      margin-bottom: 20px;
    }
  }

  p, span {
    font-size: 1.2rem;
    margin-bottom: 10px;
    letter-spacing: 0.05rem;
  }
  
  span {
    font-weight: bold;
  }

  section {
    display: flex;
    flex-direction: column;

    img {
      width: 100%;
      max-width: 300px;
      margin-top: 5px;
      margin-bottom: 5px;
    }
  }

  div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    h1 {
      font-weight: bold;
      font-size: 1.9rem;
      color: ${({ theme }) => theme.text};
    }
    button {
      border: none;
      background-color: transparent;
      font-weight: bold;
      font-size: 1.9rem;
      cursor: pointer;
      color: ${({ theme }) => theme.text};
    }
  }
`

export const Divisor = styled.div`
  display: flex;
  height: 1px;
  padding: 1px;
  width: 100%;
  background-color: ${({ theme }) => theme.text};
  margin-bottom: 10px;
`